import PersonIcon from '@material-ui/icons/Person';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Chip from '@material-ui/core/Chip';
import VideoCallIcon from '@material-ui/icons/VideoCall';
import TextField from '@material-ui/core/TextField';
import AddCommentIcon from '@material-ui/icons/AddComment';
import Tooltip from '@material-ui/core/Tooltip';
import RemoveIcon from '@material-ui/icons/Remove';
import CloseIcon from '@material-ui/icons/Close';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { MainListItems_Clinics } from '../admin_dashboard/clinicNavBar';
import { useSelector, useDispatch } from "react-redux"
import { Button, Icon, Avatar } from '@material-ui/core';
import * as AuthActions from "../../store/actions/auth";
import SharedAppBar from '../admin_dashboard/SharedAppBar';
import Auth from "../../Landingpagecomponents/Header/auth";
import { withRouter, useHistory } from "react-router-dom";
import Yourdiagnosis from '../user_dashboard/data/Yourdiagnosis';
import Prognosis from "../user_dashboard/data/Prognosis";
import Treatmentadvices from "../user_dashboard/data/treatmentadvice/Treatmentadvice";
import { withStyles } from "@material-ui/core/styles";
import CareProviderList from './CareProviders/careProviderList';
import ExerciseLibrary from '../admin_dashboard/exerciseLibraryFolder/exerciseLibrary';
import Exercise_Searchbar from '../admin_dashboard/exerciseLibraryFolder/searchExercise';
import SelectedPatientExercises from '../admin_dashboard/singlePatientOverviewFolder/selectedPatientProgramBuilder';
import CRMAdminDashboard from './CRMAdminDashboard';
import SecurityDashboard from './SecurityDashboard';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { ChatSystemContainer } from '../../components/ChatSystem';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Virtus Physio | Your Virtual Physiotherapist
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}


const drawerWidth = 178;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '100vh',
    overflow: 'hidden',
    position: 'relative',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    paddingBottom: 7,
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: 57,
    boxShadow: '0 2px 4px rgba(40,40,40,0.22), 0 2px 6px rgba(40,40,40,0.28)',
    [theme.breakpoints.down('xs')]: {
      height: 50,
    },
    [theme.breakpoints.up('sm')]: {
      height: 57,
    },
    [theme.breakpoints.up('md')]: {
      height: 57,
    },
  },
  responsiveLogo: {
    marginTop: 8,
    maxWidth: 200,
    minWidth: 165,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 120,
      minWidth: 165,
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: 180,
      minWidth: 165,
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: 190,
      minWidth: 165,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 190,
      minWidth: 165,
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: 190,
      minWidth: 165,
    },
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(7),
    },
  },
  appBarSpacer: {
    minHeight: 57,
    [theme.breakpoints.down('xs')]: {
      minHeight: 50,
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: 57,
    },
    [theme.breakpoints.up('xl')]: {
      minHeight: 57,
    },
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflowY: 'auto',
    marginTop: 0,
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 'auto',
  },
  smallIconButton: {
    padding: 8,
    marginLeft: 8,
  },
  smallAvatar: {
    width: theme.spacing(3.5),
    height: theme.spacing(3.5),
  },
}));


export default function Superuser_adminDashboard() {
  const [isLoggedIn, setIsLoggedIn] = useState(useSelector(state => state.auth.isLoggedIn))
  const [isLoading, setIsLoading] = useState(false)

  const [token, _] = useState(useSelector(state => state.auth.token))
  const [isFetching, setIsFetching] = useState(false)
  const [diagnosis, setDiagnosis] = useState({
    title: "",
    identifier: "",
    explainer: ""
  })

  const [prognosis, setPrognosis] = useState({
    Expected_outcome: "",
    Typical_character_Symptoms: "",
    Expected_average_duration: "",
    Expected_development: "",
    If_your_symptoms_worsens: ""
  })

  const [exercises, setExercises] = useState([])
  const [current_exercise_ind, setCurrent_exercise_ind] = useState(0)
  const [webcamDialogOpen, setWebcamDialogOpen] = useState(false);
  const handleOpenWebcamDialog = () => setWebcamDialogOpen(true);
  const handleCloseWebcamDialog = () => setWebcamDialogOpen(false);
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [currentTab, setCurrentTab] = useState(0);
  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

  if (!isLoggedIn || !token) {
    window.location.replace("/");
    return <div>Redirecting...</div>;
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      {/* <SharedAppBar
        open={open}
        drawerWidth={178}
        showMessages={true}
        showVideocall={true}
        onVideocallClick={handleOpenWebcamDialog}
      /> */}
      <Dialog open={webcamDialogOpen} onClose={handleCloseWebcamDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Start Videocall Consultation</DialogTitle>
        <DialogContent>
          <div style={{ textAlign: 'center', padding: 24 }}>
            <VideoCallIcon style={{ fontSize: 48, color: '#002D55', marginBottom: 16 }} />
            <div style={{ marginBottom: 16, fontWeight: 500, fontSize: 18 }}>Webcam would be initiated here.</div>
            <Button variant="contained" color="primary" onClick={handleCloseWebcamDialog}>Close</Button>
          </div>
        </DialogContent>
      </Dialog>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <Grid className={classes.appBar} style={{backgroundColor: "#002D55"}}/>
        <Divider />
        <List style={{marginLeft: open ? 0 : 0}}>
          <ListItem style={{ minHeight: 56, margin: 0, paddingLeft: 3, justifyContent: 'flex-start' }}>
            <IconButton
              onClick={open ? handleDrawerClose : handleDrawerOpen}
              style={{ marginLeft: 0 }}
            >
              <MenuIcon style={{ fontSize: 28, color: '#002D55' }} />
            </IconButton>
          </ListItem>
          <MainListItems_Clinics open={open} />
        </List>
        <Divider />
      </Drawer>
      <main className={classes.content} style={{ background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)' }}>
        <Grid Container maxWidth="100%" className={classes.container}>
          <Paper style={{ marginTop: 16, marginBottom: 16, borderRadius: 8 }}>
            <Tabs
              value={currentTab}
              onChange={(e, newValue) => setCurrentTab(newValue)}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              style={{ borderBottom: '2px solid #F79500' }}
            >
              <Tab label="Care Providers" style={{ fontWeight: 600, color: '#002D55' }} />
              <Tab label="CRM Dashboard" style={{ fontWeight: 600, color: '#002D55' }} />
              <Tab label="Security" style={{ fontWeight: 600, color: '#002D55' }} />
            </Tabs>
          </Paper>
          <Grid container spacing={0}>
            <Grid item xs={12} md={12} lg={12}>
              {currentTab === 0 && <CareProviderList />}
              {currentTab === 1 && <CRMAdminDashboard />}
              {currentTab === 2 && <SecurityDashboard />}
            </Grid>
          </Grid>
        </Grid>
        <ChatSystemContainer />
      </main>
    </div>
  );
}
